<template>
    <div>
        <loading-component :value="loading"></loading-component>
        <v-card>
            <v-form ref="contract_form">
                <v-container>
                    <v-flex>
                        <div class="px-3">
                            <v-img :src="files.contract.url ? files.contract.url : api.GET_IMAGE(contract.contract_document)"
                                   width="60%"
                                   v-if="files.contract.url || contract.contract_document"></v-img>
                            <v-text-field label="Upload Contract"
                                          @click='$refs.contract.click()'
                                          v-model='files.contract.name'
                                          :rules="required_file ? fileRules : []"
                                          append-icon='attach_file'
                                          readonly></v-text-field>
                            <input type="file" style="display: none" ref="contract"
                                   accept="image/*,application/pdf" @change="onFilePicked('contract')">
                        </div>
                    </v-flex>

                    <v-flex>
                        <div class="px-3">
                            <v-select
                                    label="Choose contract template"
                                    v-model="selected_item"
                                    :items="items"
                                    :rules="requiredRules"
                                    item-text="name"
                                    return-object
                            ></v-select>
                            <div v-if="selected_item">
                                <p class="grey--text">
                                    Percentage: {{selected_item.percentage}}%,
                                    Per hour: {{selected_item.per_hour}}%,
                                    Per KM: {{selected_item.per_km}}%,
                                    Per booking: {{selected_item.per_booking}}
                                </p>

                                <v-select
                                        label="Choose level"
                                        v-model="selected_level"
                                        :items="levels"
                                        :rules="requiredRules"
                                        item-text="name"
                                        return-object
                                ></v-select>

                                <v-select
                                        v-if="selected_level"
                                        v-model="selected_bonus_packages"
                                        label="Choose bonus packages"
                                        multiple
                                        :items="selected_level.bonus_packages"
                                        item-value="id"
                                        item-text="name"
                                ></v-select>
                            </div>
                        </div>
                    </v-flex>

                </v-container>
            </v-form>
        </v-card>
    </div>
</template>
<script>
    import LoadingComponent from "@/components/LoadingComponent";

    export default {
        name: "ContractInfo",
        components: {LoadingComponent},
        props: {
            required_file: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                loading: false,
                fileRules: [
                    v => !!v || 'File is required',
                ],
                numberRules: [
                    v => !!v || 'Required field',
                    v => /^[0-9]*$/.test(v) || 'invalid value'
                ],
                requiredRules: [
                    v => !!v || 'Field is required'
                ],
                original_contract: {},
                contract: {},
                files: {
                    contract: {},
                },
                items: [],
                selected_item: null,
                captain_id: null,
                levels: null,
                selected_level: null,
                selected_bonus_packages: [],
            }
        },
        mounted() {
            this.axios
                .get(
                    "all_contract_template"
                )
                .then((res) => {
                    this.items = res.data.data;
                }).catch(err => console.log(err.message))
                .finally(() => this.loading = false);
        },
        watch: {
            selected_item: {
                handler(val) {
                    if (val) {
                        this.loading = true;
                        this.axios.get(`contract_template/${this.selected_item.id}/level`)
                            .then(res => this.levels = res.data.data)
                            .catch(err => console.log(err.message))
                            .finally(() => this.loading = false);
                    }
                },
                deep: true
            }
        },
        methods: {
            contractChanged() {
                this.contract.contract_template_id = this.selected_item.id;
                return this.contract.contract_template_id !== this.original_contract.contract_template_id
                    || this.selected_level;
            },
            reset() {
                this.original_contract = {};
                this.contract = {};
                this.files = {
                    contract: {}
                };
                this.$refs.contract_form.reset();
            },
            update(captain_id, disable_active_contract = false) {
                this.reset();
                this.captain_id = captain_id;
                if (disable_active_contract) {
                    return;
                }
                this.loading = true;
                this.axios.get(`captain/${captain_id}/active_contract`)
                    .then(res => {
                        this.contract = res.data.data;
                        if (!this.contract) {
                            this.contract = {};
                        }
                        this.original_contract = JSON.parse(JSON.stringify(this.contract));
                        if (this.contract.contract_document) {
                            this.files.contract = {name: 'Contract document'};
                        }
                    }).catch(err => console.log(err.message))
                    .finally(() => this.loading = false);

            },
            async submit() {

                if (!this.$refs.contract_form.validate()) {
                    this.$emit('done');
                    return;
                }

                this.contract.contract_template_id = this.selected_item.id;
                const formData = new FormData();

                const config = {
                    headers: {
                        'content-type': 'multipart/form-data'
                    }
                };

                this.loading = true;

                if (this.files.contract.changed || this.contractChanged()) {

                    if (this.files.contract.changed) {
                        formData.append('contract_document', this.files.contract.file);
                    }

                    let url = 'contract';
                    if (this.contractChanged()) {
                        formData.append('captain_id', this.captain_id);
                        formData.append('contract_template_id', this.contract.contract_template_id);
                        formData.append('level_id', this.selected_level.id);
                        if (this.selected_bonus_packages.length) {
                            this.selected_bonus_packages.forEach(e => formData.append('bonus_packages[]', e));
                        }
                    } else {
                        url += `/${this.contract.id}`;
                        formData.append('_method', 'PUT');
                    }
                    await this.axios.post(url, formData, config)
                        .then(() => this.$emit('next_step'))
                        .catch(err => {
                            try {
                                if (err.response.data.message) {
                                    window.getApp.$emit("SHOW_TOAST", err.response.data.message, "red", ['center', 'top']);
                                } else {
                                    window.getApp.$emit("SHOW_TOAST", err.message, "red", ['center', 'top']);
                                }
                            } catch (e) {
                                console.log(err.message, e.message);
                            }
                        }).finally(() => this.$emit('done'));
                } else {
                    this.$emit('next_step');
                    this.$emit('done');
                }
                this.loading = false;
            },
            onFilePicked(type) {
                const files = this.$refs[type].files;
                if (files[0] !== undefined) {
                    this.files[type].changed = true;
                    this.files[type].name = files[0].name;
                    if (this.files[type].name.lastIndexOf('.') <= 0) {
                        return;
                    }
                    const fr = new FileReader();
                    fr.readAsDataURL(files[0]);
                    fr.addEventListener('load', () => {
                        this.$set(this.files[type], 'url', fr.result);
                        // this.files[type].url = fr.result;
                        this.files[type].file = files[0];
                    })
                } else {
                    this.files[type] = {};
                }
            },
        }
    }
</script>

<style scoped>

</style>
